// extracted by mini-css-extract-plugin
export default {"new_session":"NewSession_new_session__mLumR"};